<div>
  <img
    style="object-fit: cover; height: 750px; width: 100%"
    src="{{ data.urlImage }}"
  />
</div>
